import { client } from '../index'
import { MeQueryQuery, MeQueryQueryVariables } from '../types'
import { ME_QUERY } from '../graphql/me.query'
import { ApolloQueryResult } from '@apollo/client'

const localStorageKey = '__personae_token__'

const getToken = async (): Promise<string | null> => {
  return window.localStorage.getItem(localStorageKey)
}

const logout = async (): Promise<void> => {
  client.stop()
  client.resetStore()
  window.localStorage.removeItem(localStorageKey)
  window.history.replaceState({}, '', '/')

  return Promise.resolve()
}

const me = (): Promise<ApolloQueryResult<MeQueryQuery>> => {
  return client.query<MeQueryQuery, MeQueryQueryVariables>({
    query: ME_QUERY,
  })
}

export { getToken, logout, me, localStorageKey }
